import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {
  IStateDashboardSearchFields,
  IStateDashboardSearchRequest,
} from '@core/interfaces/istate-dashboard';
import { DownloadRequestService } from '@core/services/download-request.service';
import { ConfirmationModalComponent } from '@shared/components/confirmation-modal/confirmation-modal.component';
import { take } from 'rxjs';
import { TranslocoService } from '@jsverse/transloco';

@Component({
    selector: 'drdp-search-child-ratings',
    templateUrl: './search-child-ratings.component.html',
    styleUrls: ['./search-child-ratings.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchChildRatingsComponent {
  private downloadService = inject(DownloadRequestService);
  dialog = inject(MatDialog);
  private translocoService = inject(TranslocoService);

  displayDropdowns: IStateDashboardSearchFields = {
    ageGroup: false,
    enrollmentProgram: false,
    homeLanguage: false,
    schoolYear: true,
    globalRatingPeriods: true,
    disability: false,
    siteLevelCounty: true
  };
  requiredFields: IStateDashboardSearchFields = {
    ageGroup: false,
    enrollmentProgram: false,
    homeLanguage: false,
    globalRatingPeriods: true,
    disability: false,
  };

  handleSearch(searchValue: IStateDashboardSearchRequest): void {
    const payload = {
      stateId: searchValue.stateId,
      agencyId: searchValue.agencyId,
      ratingPeriodIds: searchValue.globalRatingPeriodIds
    };

    this.downloadService
      .saveStateDashRatingsRequest(payload)
      .pipe(take(1))
      .subscribe((res) => {
        if (res) this.displaySuccessMessage();
      });
  }

  displaySuccessMessage() {
    const modal = {
      data: {
        modalInfo: {
          title: this.translocoService.translate('user.stateDashboard.export.successTitle'),
          message:
            this.translocoService.translate('user.stateDashboard.export.requestProcessing'),
          primaryBtnClass: 'blue',
          primaryBtnText: this.translocoService.translate('user.stateDashboard.export.ok'),
          showCancel: false,
        },
      },
    };

    this.dialog.open(ConfirmationModalComponent, {
      data: modal,
    });
  }
}
